// Patient overview section form field enum
export enum PatientOverviewFormField {
  // Demographics
  PATIENT_OVERVIEW_DEMOGRAPHICS_LEGAL_NAME = 'legal-name',
  PATIENT_OVERVIEW_DEMOGRAPHICS_PREFERRED_NAME = 'preferred-name',
  PATIENT_OVERVIEW_DEMOGRAPHICS_DATE_OF_BIRTH = 'date-of-birth',
  PATIENT_OVERVIEW_DEMOGRAPHICS_ADDRESS = 'address',
  PATIENT_OVERVIEW_DEMOGRAPHICS_GENDER = 'gender',
  PATIENT_OVERVIEW_DEMOGRAPHICS_SEX = 'sex',
  PATIENT_OVERVIEW_DEMOGRAPHICS_MEDICAID_ID = 'medicaid-id',
  PATIENT_OVERVIEW_DEMOGRAPHICS_SSN = 'ssn',
  PATIENT_OVERVIEW_DEMOGRAPHICS_PRIMARY_LANGUAGE = 'primary-language',
  PATIENT_OVERVIEW_DEMOGRAPHICS_RELIGION = 'religion',
  PATIENT_OVERVIEW_DEMOGRAPHICS_RACE = 'race',

  // Care Team
  PATIENT_OVERVIEW_CARE_TEAM_LEGAL_GUARDIAN_NAME = 'legal-guardian-name',
  PATIENT_OVERVIEW_CARE_TEAM_LEGAL_GUARDIAN_RELATION_TO_PATIENT = 'legal-guardian-relation-to-patient',
  PATIENT_OVERVIEW_CARE_TEAM_CAREGIVER = 'caregivers', // Form.List array field
  PATIENT_OVERVIEW_CARE_TEAM_ORDERING_PRACTITIONER = 'ordering-practitioner',
  PATIENT_OVERVIEW_CARE_TEAM_PRIMARY_CARE_PROVIDER = 'primary-care-provider',
  PATIENT_OVERVIEW_CARE_TEAM_ORDER_PREFERENCE = 'order-preference',
  PATIENT_OVERVIEW_CARE_TEAM_SOC_DATE = 'soc-date',
  PATIENT_OVERVIEW_CARE_TEAM_F2F_DATE = 'f2f-date',
  PATIENT_OVERVIEW_CARE_TEAM_EMERGENCY_CONTACT_NAME = 'emergency-contact-name',
  PATIENT_OVERVIEW_CARE_TEAM_EMERGENCY_CONTACT_PHONE = 'emergency-contact-phone',
  PATIENT_OVERVIEW_CARE_TEAM_EMERGENCY_CONTACT_ADDRESS = 'emergency-contact-address',
  PATIENT_OVERVIEW_CARE_TEAM_ALTERNATE_CAREGIVER_NAME = 'alternate-caregiver-name',
  PATIENT_OVERVIEW_CARE_TEAM_ALTERNATE_CAREGIVER_PHONE = 'alternate-caregiver-phone',
  PATIENT_OVERVIEW_CARE_TEAM_ALTERNATE_CAREGIVER_ADDRESS = 'alternate-caregiver-address'
}
